import { useEffect, useState } from 'react';

// Returns true once a query has finished loading at least once. Use it to show a full-page
// skeleton only on the initial load: later reloads (sort/filter/search/tab changes that
// re-trigger isLoading) should keep the page chrome and skeleton just the table instead.
export const useHasLoadedOnce = (isLoading: boolean): boolean => {
  const [hasLoadedOnce, setHasLoadedOnce] = useState(false);

  useEffect(() => {
    if (!isLoading) setHasLoadedOnce(true);
  }, [isLoading]);

  return hasLoadedOnce;
};
